function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Form, Input, Button, Select, InputNumber, Modal, Alert } from "antd";
import Common from '../includes/Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var AddOrder = function AddOrder(_ref) {
  var handler = _ref.handler,
    provider = _ref.provider,
    station = _ref.station;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    productsOptions = _useState8[0],
    setProductsOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    productList = _useState10[0],
    setProductList = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    configurationList = _useState12[0],
    setConfigurationList = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    configOptions = _useState14[0],
    setConfigOptions = _useState14[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var saveOrder = function saveOrder(values, up) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('quantity', values.quantity);
    formData.append('gas_station_id', station.id);
    formData.append('provider_id', provider.id);
    formData.append('unit_price', up);
    formData.append('status', 0);
    formData.append('delivered_quantity', 0);
    formData.append('paid_amount', 0);
    formData.append('product_id', values.product_id);
    formData.append('configuration_id', values.configuration_id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addorder', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    var selectedProduct = productList.filter(function (p) {
      return p.id == values.product_id;
    })[0];
    var selectedConfig = configurationList.filter(function (c) {
      return c.id == values.configuration_id;
    })[0];
    var unit_price = selectedProduct.label.slice(3) == 'ESS' ? selectedConfig.petrol_purchase_price : selectedConfig.diesel_purchase_price;
    confirm({
      title: 'Confirmez-vous la création de la commande ?',
      content: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("ul", {
          children: [/*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Fournisseur: "
            }), " ", provider.label, " "]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Quantit\xE9: "
            }), " ", values.quantity.toLocaleString('Fr'), " LITRES"]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Produit: "
            }), " ", productsOptions.filter(function (p) {
              return p.value = values.product_id;
            })[0].label, " "]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("b", {
              children: "Prix d'achat par litre: "
            }), unit_price.toLocaleString('Fr'), " GNF"]
          })]
        })
      }),
      onOk: function onOk() {
        saveOrder(values, unit_price);
      }
    });
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + 'getproducts/' + station.id.toString() + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getconfigurations/' + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status != 200 || response[1].data.status != 200) return message.error({
        content: 'Une erreur est survenue pendant le chargement',
        delay: 4
      });
      setProductList(response[0].data.products);
      response[0].data.products.forEach(function (p) {
        if (p.category == 0) setProductsOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            value: p.id,
            label: p.label
          }]);
        });
      });
      setConfigurationList(response[1].data.configurations);
      response[1].data.configurations.forEach(function (c) {
        setConfigOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: "ESS(".concat(c.petrol_user_price.toLocaleString('Fr'), " - ").concat(c.petrol_purchase_price.toLocaleString('Fr'), " GNF)"),
            value: c.id
          }]);
        });
      });
      if (response[1].data.configurations.length > 0 && response[1].data.configurations.filter(function (c) {
        return c.default_selected == 1;
      }).length > 0) form.setFieldsValue({
        configuration_id: response[1].data.configurations.filter(function (c) {
          return c.default_selected == 1;
        })[0].id
      });
      if (response[0].data.products.length > 0) form.setFieldsValue({
        product_id: response[0].data.products.filter(function (p) {
          return p.id == response[0].data.products[0].id && p.category == 0;
        })[0].id
      });
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      style: {
        background: '#FFCE00'
      },
      children: ["Initier une nouvelle commande pour votre station ", /*#__PURE__*/_jsx("b", {
        children: station.label
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "product_id",
        label: "Produit",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: productsOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "configuration_id",
        label: "Schema de prix",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: configOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "quantity",
        label: "Quantit\xE9",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "LITRES",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: productsOptions.length == 0,
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER"
          })
        })
      })]
    })]
  });
};
export default AddOrder;